// Clipboard with a fallback: navigator.clipboard only exists on secure origins
// (https / localhost) — on a LAN http:// origin it's undefined, so writing to
// it silently does nothing. execCommand works everywhere.
export const copyText = async (text) => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (_) { /* fall through */ }
  try {
    const ta = document.createElement('textarea');
    ta.setAttribute('data-clipboard-helper', '1');   // lets the floating calculator tell this focus from the person moving elsewhere
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch (_) {
    return false;
  }
};
